/**
 * @created: 2020/09/02
 * @desc 通道发行
 * @author: Colorfule
 * @version : v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 获取列表
export const getListData = params => {
  return request.get('/mer/channel/publish/list', params)
}

// 获取商户详情信息
export const getMerchantDetails = params => {
  return request.get('/mer/channel/publish/getMerchantDetail', params)
}

// 获取SIM卡号列表
export const getPublishSIMList = params => {
  return request.get('/mer/channel/publish/simlist', params)
}

// 获取终端序列号列表
export const getPublishPosList = params => {
  return request.get('/mer/channel/publish/poslist', params)
}

// 查询商户支付通道更换历史
export const getChannelHistory = params => {
  return request.get('/mer/channel/publish/listModifyPayChannelHistory', params)
}


// 获取商户聚合支付信息(支付终端信息)
export const getQueryUnionPayment = params => {
  return request.get('/mer/channel/publish/queryUnionPayment', params)
}

// 修改商户聚合支付信息
export const updateUnionPayment = data => {
  return request.post('/mer/channel/publish/updateUnionPayment', qs.stringify(data))
}

// 发行(批量发行.单个发行)
export const publish = params => {
  return request.get('/mer/channel/publish/publish', params)
}